var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import startsWith from 'lodash/startsWith';
import moment from 'moment-timezone';
export var convertToBusinessProfile = function (dto, masterData) {
    return {
        id: dto.id,
        uuid: dto.uuid,
        legalName: dto.legal_name,
        tradeName: dto.trade_name,
        einNumber: dto.ein_number,
        email: dto.email,
        website: dto.website,
        phoneType: masterData.payments.phoneTypes.find(function (phoneType) { return phoneType.id === dto.phone_type_id; }),
        phoneNumber: startsWith(dto.phone, '+1') ? dto.phone.substring(2, dto.phone.length) : dto.phone,
        address: {
            street: dto.address_street,
            streetNumber: dto.address_street_number,
            city: dto.address_city,
            state: dto.address_state,
            zipcode: dto.address_zip_code,
            country: masterData.countryCodes.find(function (countryCode) { return countryCode.alpha2 === dto.address_country; }),
        },
        termsOfService: dto.terms_of_service,
        document: dto.document_url
            ? {
                url: dto.document_url,
                fileName: dto.document_filename,
                fileSize: dto.document_filesize,
                file: new File([dto.document_url], dto.document_filename),
            }
            : undefined,
        verificationStatus: masterData.payments.verificationStatuses.find(function (status) { return status.id === dto.verification_status_id; }),
        editable: dto.editable,
        active: dto.active,
    };
};
export var convertToShareholder = function (dto, masterData) {
    var _a;
    return {
        id: dto.id,
        uuid: dto.uuid,
        gender: masterData.payments.genders.find(function (gender) { return gender.id === dto.gender_id; }),
        firstName: dto.first_name,
        lastName: dto.last_name,
        email: dto.email,
        dateOfBirth: moment(dto.date_of_birth, 'YYYY-MM-DD'),
        documentType: (_a = masterData.payments.documentTypes) === null || _a === void 0 ? void 0 : _a.shareholder.find(function (documentType) { return documentType.id === dto.document_type_id; }),
        documentNumber: dto.document_number,
        phoneNumber: startsWith(dto.phone, '+1') ? dto.phone.substring(2, dto.phone.length) : dto.phone,
        address: {
            street: dto.address_street,
            streetNumber: dto.address_street_number,
            city: dto.address_city,
            state: dto.address_state,
            zipcode: dto.address_zip_code,
            country: masterData.countryCodes.find(function (countryCode) { return countryCode.alpha2 === dto.address_country; }),
        },
        document: dto.document_url
            ? {
                url: dto.document_url,
                fileName: dto.document_filename,
                fileSize: dto.document_filesize,
                file: new File([dto.document_url], dto.document_filename),
            }
            : undefined,
        documentFront: dto.document_front_url
            ? {
                url: dto.document_front_url,
                fileName: dto.document_front_filename,
                fileSize: dto.document_front_filesize,
                file: new File([dto.document_front_url], dto.document_front_filename),
            }
            : undefined,
        documentBack: dto.document_back_url
            ? {
                url: dto.document_back_url,
                fileName: dto.document_back_filename,
                fileSize: dto.document_back_filesize,
                file: new File([dto.document_back_url], dto.document_back_filename),
            }
            : undefined,
        verificationStatus: masterData.payments.verificationStatuses.find(function (status) { return status.id === dto.verification_status_id; }),
        editable: dto.editable,
        active: dto.active,
    };
};
export var convertToBankAccount = function (dto, masterData) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    return {
        id: (_a = dto.id) !== null && _a !== void 0 ? _a : null,
        uuid: (_b = dto.uuid) !== null && _b !== void 0 ? _b : null,
        ownerName: (_c = dto.owner_name) !== null && _c !== void 0 ? _c : null,
        accountNumber: (_d = dto.account_number) !== null && _d !== void 0 ? _d : null,
        description: (_e = dto.description) !== null && _e !== void 0 ? _e : null,
        routingNumber: (_f = dto.routing_number) !== null && _f !== void 0 ? _f : null,
        accountType: (_g = masterData.payments.bankAccountTypes.find(function (type) { return type.id === dto.account_type_id; })) !== null && _g !== void 0 ? _g : null,
        country: (_h = masterData.countryCodes.find(function (country) { return country.alpha2 === dto.country_code; })) !== null && _h !== void 0 ? _h : null,
        currency: (_j = masterData.payments.currencies.find(function (currency) { return currency.id === dto.currency_id; })) !== null && _j !== void 0 ? _j : null,
        primary: (_k = dto.primary) !== null && _k !== void 0 ? _k : false,
        document: dto.document_url
            ? {
                url: dto.document_url,
                fileName: (_l = dto.document_filename) !== null && _l !== void 0 ? _l : '',
                fileSize: (_m = dto.document_filesize) !== null && _m !== void 0 ? _m : 0,
                file: new File([dto.document_url], (_o = dto.document_filename) !== null && _o !== void 0 ? _o : ''),
            }
            : null,
        verificationStatus: (_p = masterData.payments.verificationStatuses.find(function (status) { return status.id === dto.verification_status_id; })) !== null && _p !== void 0 ? _p : null,
        editable: (_q = dto.editable) !== null && _q !== void 0 ? _q : null,
        active: (_r = dto.active) !== null && _r !== void 0 ? _r : null,
        updatedAt: dto.updated_at ? moment(dto.updated_at) : null,
        accountIdentifier: (_s = dto.accountIdentifier) !== null && _s !== void 0 ? _s : null,
        realLastFour: (_t = dto.realLastFour) !== null && _t !== void 0 ? _t : null,
        trustedSource: (_u = dto.trustedSource) !== null && _u !== void 0 ? _u : null, // New field for Adyen response
    };
};
export var convertToDropIn = function (dto) {
    var _a;
    return {
        amount: __assign({}, dto.amount),
        countryCode: dto.countryCode,
        channel: dto.channel,
        expiresAt: dto.expiresAt,
        id: dto.id,
        merchantAccount: dto.merchantAccount,
        reference: dto.reference,
        returnUrl: dto.returnUrl,
        sessionData: dto.sessionData,
        shopperName: __assign({}, dto.shopperName),
        shopperReference: dto.shopperReference,
        splits: ((_a = dto.splits) === null || _a === void 0 ? void 0 : _a.map(function (split) { return (__assign({}, split)); })) || [],
        trustedShopper: dto.trustedShopper,
    };
};
export var convertToDropInAdmin = function (dto) {
    return {
        amount: __assign({}, dto.amount),
        countryCode: dto.countryCode,
        channel: dto.channel,
        expiresAt: dto.expiresAt,
        id: dto.id,
        merchantAccount: dto.merchantAccount,
        reference: dto.reference,
        returnUrl: dto.returnUrl,
        sessionData: dto.sessionData,
        shopperName: __assign({}, dto.shopperName),
        shopperReference: dto.shopperReference,
        trustedShopper: dto.trustedShopper,
    };
};
export var convertToEnrollmentStatus = function (dto, masterData, timeZone) {
    var _a, _b, _c;
    var shareholders = convertToEnrollmentStatusItem(dto.shareholders, masterData, timeZone);
    return {
        bankAccounts: convertToEnrollmentStatusItem(dto.bank_accounts, masterData, timeZone),
        businessProfile: convertToEnrollmentStatusItem(dto.business_profile, masterData, timeZone),
        enabled: dto.enabled || false,
        showEnrollment: dto.psp_enrollment || false,
        primaryBankAccount: convertToEnrollmentStatusItem(dto.primary_bank_account, masterData, timeZone),
        shareholders: shareholders
            ? __assign(__assign({}, shareholders), { documentType: (_c = (_b = (_a = masterData.payments) === null || _a === void 0 ? void 0 : _a.documentTypes) === null || _b === void 0 ? void 0 : _b.shareholder) === null || _c === void 0 ? void 0 : _c.find(function (documentType) { var _a; return documentType.id === ((_a = dto.shareholders) === null || _a === void 0 ? void 0 : _a.document_type_id); }) }) : null,
        pciStatus: masterData.payments.verificationStatuses.find(function (status) { return status.id === (dto === null || dto === void 0 ? void 0 : dto.pci_compliance); }) || null,
        verificationStatus: dto.verification_status,
    };
};
var convertToEnrollmentStatusItem = function (dto, masterData, timeZone) {
    var verificationStatus = masterData.payments.verificationStatuses.find(function (status) { return status.id === (dto === null || dto === void 0 ? void 0 : dto.status); }) || null;
    if (dto === null || verificationStatus === null) {
        return null;
    }
    else {
        return {
            verificationStatus: verificationStatus,
            updatedAt: moment(dto.updated_at).tz(timeZone),
            hasDocument: dto.attached_document,
        };
    }
};
export var convertToPaymentsResult = function (dto, masterData, marketplace) { return dto.payments.map(function (payment) { return convertToPayment(payment, masterData, marketplace); }); };
export var convertToPaymentsPageResult = function (dto, masterData, marketplace) {
    return {
        page: dto.payments.map(function (payment) { return convertToPayment(payment, masterData, marketplace); }),
        pagination: convertToPagination(dto),
        searchText: null,
        sort: null,
    };
};
export var convertToRefundsResult = function (dto, masterData, marketplace) { return dto.refunds.map(function (refund) { return convertToRefund(refund, masterData, marketplace); }); };
export var convertToRefundsPageResult = function (dto, masterData, marketplace) {
    return {
        page: dto.refunds.map(function (refund) { return convertToRefund(refund, masterData, marketplace); }),
        pagination: convertToPagination(dto),
        searchText: null,
        sort: null,
    };
};
export var convertToPayouts = function (dto, pageNumber) {
    return {
        page: (dto.transactions || dto.items || []).map(function (transaction) { return convertToPayout(transaction); }),
        pageNumber: pageNumber,
        hasNextPage: dto.has_next_page,
    };
};
var convertToPagination = function (dto) {
    return {
        page: dto.page,
        pageSize: dto.size,
        totalPages: dto.total_pages,
        totalRecords: dto.total_records,
    };
};
export var convertToPayment = function (dto, masterData, marketplace) {
    var _a;
    return {
        id: dto.id,
        uuid: dto.uuid,
        amount: dto.amount,
        paidAt: moment(dto.created_at).tz(marketplace.schedule.timeZone),
        customer: {
            id: dto.customer_id,
            name: dto.customer_name,
            phone: dto.customer_phone,
        },
        invoice: {
            id: dto.invoice_id,
            uuid: dto.invoice_uuid,
            number: dto.invoice_number,
            pdfUrl: dto.pdf_file_url,
        },
        paymentMethod: {
            id: dto.payment_method_id,
            name: ((_a = masterData.payments.paymentMethods.find(function (paymentMethod) { return paymentMethod.id === dto.payment_method_id; })) === null || _a === void 0 ? void 0 : _a.name) ||
                '',
            cardDigits: dto.card_digits,
        },
        pspReference: dto.psp_reference,
        pspSessionId: dto.psp_session_id,
        reference: dto.reference,
        riskScore: dto.risk_score,
        status: masterData.payments.statuses.find(function (status) { return status.id === dto.status_id; }),
        refunds: dto.refunds.map(function (refund) { return convertToRefund(refund, masterData, marketplace); }),
        balance: dto.current_balance,
        refundable: dto.refundable,
        authorizationCode: dto.authorization_code,
        card: {
            cardholderName: dto.cardholder_name,
            digits: dto.card_digits,
            bin: dto.card_bin,
            issuer_country: dto.card_issuer_country,
            expiration: dto.card_expiration,
        },
        transaction: {
            statusId: dto.status_id,
            date: moment(dto.transaction_date).tz(marketplace.schedule.timeZone),
        },
        createdAt: moment(dto.created_at).tz(marketplace.schedule.timeZone),
        updatedAt: moment(dto.updated_at).tz(marketplace.schedule.timeZone),
    };
};
export var convertToRefund = function (refundDto, masterData, marketplace) {
    return {
        id: refundDto.id,
        uuid: refundDto.uuid,
        amount: refundDto.amount,
        refundDate: moment(refundDto.created_at).tz(marketplace.schedule.timeZone),
        reference: refundDto.psp_reference,
        reason: refundDto.reason,
        status: masterData.payments.refundStatuses.find(function (status) { return status.id === refundDto.status_id; }),
        payment: {
            id: refundDto.payment.id,
            paymentMethod: masterData.payments.paymentMethods.find(function (paymentMethod) { return paymentMethod.id === refundDto.payment.payment_method; }),
            cardDigits: refundDto.payment.card_digits,
        },
        customer: {
            id: refundDto.customer.id,
            firstName: refundDto.customer.first_name,
            lastName: refundDto.customer.last_name,
        },
        invoice: {
            id: refundDto.invoice.id,
            number: refundDto.invoice.number,
        },
        chargeback: refundDto.chargeback,
    };
};
export var convertToPayout = function (payoutDto) {
    return {
        date: payoutDto.date ? moment(payoutDto.date) : payoutDto.creation_date ? moment(payoutDto.creation_date) : null,
        amount: payoutDto.value || payoutDto.amount || null,
        status: payoutDto.status || null,
        accountNumber: payoutDto.account_number || null,
        routingNumber: payoutDto.routing_number || null,
        accountType: payoutDto.bank_account_type || null,
        balancePlatform: payoutDto.balance_platform || null,
        transferReference: payoutDto.transfer_reference || null,
        currency: payoutDto.currency || null,
        balanceAccountReference: payoutDto.balance_account_reference || null,
        description: payoutDto.description || null,
        estimatedArrivalTime: payoutDto.estimated_arrival_time ? moment(payoutDto.estimated_arrival_time) : null,
    };
};
export var convertToNextPayout = function (dto, masterData) {
    return {
        amount: dto.next_payout_amount,
        date: moment(dto.next_payout_date),
        bankAccountNumber: dto.bank_account_number || null,
        bankAccount: dto.bank_account ? convertToBankAccount(dto.bank_account, masterData) : null, //Legacy profiles
    };
};
export var convertToSalesReports = function (dto, from, to) {
    return {
        completedTransactions: dto.transactions_count,
        cuddlesFees: dto.cuddles_fees_total,
        discounts: dto.discounts_total,
        grossSales: dto.gross_total,
        grossSalesAddons: dto.addons_total,
        grossSalesProducts: dto.products_total,
        grossSalesServices: dto.services_total,
        netSales: dto.net_sales,
        netTotal: dto.net_total,
        refunds: dto.refunds_total,
        tax: dto.sales_tax,
        tip: dto.tips_total,
        totalCash: dto.cash_total,
        totalCreditCards: dto.card_total,
        totalOther: dto.other_total,
        totalSales: dto.total_sales,
        totalDeposits: dto.deposits_total,
        from: (from === null || from === void 0 ? void 0 : from.clone()) || null,
        to: (to === null || to === void 0 ? void 0 : to.clone()) || null,
        customTotal: dto.custom_total,
    };
};
export var convertToPaymentMethod = function (dto) {
    return {
        name: dto.name,
        expirationMonth: dto.expiry_month,
        expirationYear: dto.expiry_year,
        holderName: dto.holder_name,
        lastDigits: dto.last_four,
    };
};
export var convertToClientPaymentMethod = function (dto) {
    return {
        id: dto.id,
        uuid: dto.uuid,
        name: dto.brand,
        lastDigits: dto.last4,
        pspToken: dto.pspToken,
        expirationMonth: dto.expiration_month.toString(),
        expirationYear: dto.expiration_year.toString(),
        holderName: dto.name,
        primary: dto.primary,
    };
};
